import React, { lazy } from "react"

// Utils
import { getIsSsrMobile } from "src/utils/getIsSsrMobile"

// Layout
const MobileRegister = lazy(() => import("src/components/pages/register/mobile"))
const DesktopRegister = lazy(() => import("src/components/pages/register/desktop"))

// Hooks
import { useIsMobile } from "src/hooks/useIsMobile"
import Head from "next/head"
import { useRouter } from "next/router"
import { useEffect } from "react"
import auth from "../../lib/auth"
import Pages from "../../constants/pages"

// -------------------------------------------|| REGISTER - PAGES ||-------------------------------------------------------

const Register = () => {
  const isMobile = useIsMobile()

  const router = useRouter()

  useEffect(() => {
    auth.ensureSession().then(isValid => {
      if (isValid) router.push(Pages.Main)
    })
  }, [])

  return (
    <>
      <Head>
        <title>ثبت نام</title>
      </Head>
      {isMobile ? <MobileRegister /> : <DesktopRegister />}
    </>
  )
}

export default Register

export async function getServerSideProps(context = GetServerSidePropsContext) {
  return {
    props: {
      isSsrMobile: getIsSsrMobile(context)
    }
  }
}
